import { BottomNavigation, BottomNavigationAction } from '@mui/material'
import { useEffect, useState } from 'react'

import { useRouter } from '@/core'
import { GlobalTabKeys } from '@/types/tabs'

import { useTabList } from './TabList'

export const GlobalBottomNavigation = ({
  tabKeys,
  hasManagementTask,
  hasSettingTask,
  unreadNotificationCount,
  defaultTab = null,
}: Props) => {
  const tabs = useTabList({
    unreadNotificationCount,
    hasManagementTask,
    hasSettingTask,
  })
  const [value, setValue] = useState(defaultTab)
  const { router } = useRouter<{ tab: string }>()

  useEffect(() => {
    const index = tabKeys.findIndex(key =>
      router.pathname.includes(tabs[key]['value'])
    )
    if (index >= 0 && tabs[tabKeys[index]]?.value) {
      setValue(tabs[tabKeys[index]].value)
      return
    }
    /**
     * /:tabのURLから初回のtabKeyの値をセットする
     */
    setValue(router.query.tab)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabKeys, tabs, router.pathname])

  /**
   * @todo
   * https://app.clickup.com/t/908127/UT-8948
   * お知らせ未読分のバッジ表示データ組み込み
   */

  return (
    <BottomNavigation value={value} showLabels sx={{ bgcolor: 'grey.50' }}>
      {tabKeys.map((key, i) => {
        const { icon, ...content } = tabs[key]

        return (
          <BottomNavigationAction
            key={i}
            icon={icon}
            {...content}
            sx={{
              maxWidth: 600 / tabKeys.length,
            }}
          />
        )
      })}
    </BottomNavigation>
  )
}

type Props = {
  tabKeys: GlobalTabKeys[number][]
  /**
   * Initial display tab.If not set, the first tab can be displayed.
   */
  defaultTab?: string | null
  /**
   * 配送申請・コンビニ決済が必要である場合true
   */
  hasManagementTask: boolean
  /**
   * True if account settings is required
   */
  hasSettingTask: boolean
  /**
   * 未読の通知数
   */
  unreadNotificationCount?: number
}
